import { useMutation } from '@apollo/client'
import {
  CreateAttendanceToleranceSettingDocument,
  type CreateAttendanceToleranceSettingMutationVariables,
} from 'generated/resources/graphql'

export const useCreateToleranceSetting = () => {
  const [createToleranceSetting, { loading }] = useMutation(
    CreateAttendanceToleranceSettingDocument
  )

  return {
    loading,
    create(variables: CreateAttendanceToleranceSettingMutationVariables) {
      return createToleranceSetting({ variables })
    },
  }
}
